<template>
  <div class="">
   <div class="sticky-top">
      <nav class="navbar navbar-expand-lg navbar-light bg-light ">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img src="./assets/images/cm-logo.png">
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarText">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link to="/" class="nav-link">Home</router-link>
              </li>
              <li class="nav-item"  v-if="!userIsLogged">
                <router-link to="/insert" class="nav-link">Inserisci</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/check" class="nav-link">Controlla</router-link>
              </li>
              
            </ul>
            
          </div>
          
        </div>
      </nav>
      
    </div>

    <div class="container-fluid pt-4">
      <router-view/>
    </div>

  </div>
</template>

<style lang="scss">
  @import "./styles/warranties.scss";
</style>



<script>

import CmMixin from '../../webapp/src/mixins/CmMixin'
// import CmMixin from './mixins/CmMixin'
import axios from 'axios'



export default{
  components:{
   
  },
  mounted: function(){

    var self = this; 
    axios.get('/config.json')
      .then(
        (response) => {

          if( response.data.api_url != undefined ){
            self.$store.commit('setApiUrl', response.data.api_url);
            
          }

        }
      ).catch( [(error) => {
        self.$store.commit('setApiUrl', '/connector');
      }]);

      
    
  },
  mixins: [ CmMixin ],
  methods:{
    
  }
}
</script>

